import axios from '../request/http.js'


class Material {
  /* 物料分类集合 */
  static getMaterialTypeList(name) {
    let url = `/zzd/api/back/material/category/list?name=${name}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增分类 */
  static postAddMaterialType(data) {
    let url = `/zzd/api/back/material/category/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除分类 */
  static postDelMaterialType(data) {
    let url = `/zzd/api/back/material/category/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 修改分类 */
  static postModMaterialType(data) {
    let url = `/zzd/api/back/material/category/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }

  /* 物料列表集合 */
  static getMaterialList(materialCategoryId) {
    let url = `/zzd/api/back/material/list?materialCategoryId=${materialCategoryId}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 开关逐日推销 */
  static postIsOpenDailySales(data) {
    let url = `/zzd/api/back/material/update/amortizationByDay`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 删除物料 */
  static postDelMaterial(data) {
    let url = `/zzd/api/back/material/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  /* 新增物料 */
  static postAddMaterial(data) {
    let url = `/zzd/api/back/material/save`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default Material